var _ellipse, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2109,
    cy: 18,
    rx: 17.5,
    ry: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6187 16.8517V16.8398C12.2408 16.8398 11.1289 17.9789 11.1289 19.3789C11.1289 20.7788 12.2408 21.9179 13.6187 21.9179C14.9965 21.9179 16.1085 20.7789 16.1085 19.3907C16.1085 17.9906 14.9844 16.8517 13.6187 16.8517Z",
    fill: "#0065FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05889 0 0 8.05889 0 18C0 27.9411 8.05889 36 18 36C27.9411 36 36 27.9411 36 18C36 8.05889 27.9411 0 18 0ZM24.6596 27.4976C24.6596 27.4976 23.7528 26.4888 23.1004 25.5992C26.2428 24.7094 27.4276 22.9298 27.4276 22.9298C24.1603 24.9499 21.1089 25.7271 18 25.6261C14.8911 25.7269 11.8397 24.9499 8.57275 22.9298C8.57275 22.9298 9.75715 24.7094 12.9 25.5992C12.2473 26.4891 11.3409 27.4976 11.3409 27.4976C5.95001 27.3789 3.8592 24.0806 3.73824 24.223C3.73824 16.879 7.30368 10.8991 7.30368 10.8991C10.4944 8.60947 13.4677 8.51429 14.0357 8.50241L14.3983 8.8465C10.3252 9.98546 8.35517 11.7652 8.35517 11.7652C11.851 10.0767 15.1458 9.48276 18 9.44719C20.8542 9.48319 24.1488 10.0767 27.6448 11.7652C27.6448 11.7652 25.6748 9.98546 21.6017 8.8465L21.9643 8.50241C22.5324 8.51429 25.5056 8.60918 28.6963 10.8991C28.6963 10.8991 32.2617 16.8788 32.2617 24.223C32.1408 24.0806 30.05 27.3789 24.6596 27.4976Z",
    fill: "#0065FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3883 16.8398V16.8517C21.0225 16.8517 19.8984 17.9908 19.8984 19.3907C19.8984 20.7789 21.0105 21.9179 22.3883 21.9179C23.7661 21.9179 24.878 20.7789 24.878 19.3789C24.878 17.9788 23.7661 16.8398 22.3883 16.8398Z",
    fill: "#0065FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.bb1438ec77266f16b8287d7b9e9bd8db.svg";
export { ForwardRef as ReactComponent };